
<div class="v-flex lm-border doc-label">
    <d-inc-document-info
        v-model   = "showInfo"
        :document = "document"
    />

    <c-inc-document-icon
        :document = "document"
        :size     = "20"
    />

    <div class="v-flex pa-0" style="margin-top: 4px; color: black; ">
        <div>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                        class="doc-name"
                    >
                        {{ document.name }}
                    </div>
                </template>

                <div>
                    {{ document.name }}
                </div>
            </v-tooltip>



        </div>

        <div class="doc-type">
            {{ document.typename }}
        </div>
        <div style="margin-top: -6px">
            <c-toolbar-button
                color   = "primary"
                icon    = "mdi-information-outline"
                tooltip = "DMS Infos zum Dokument"
                @click  = "onInfo"
            />
        </div>
    </div>
</div>
